<script setup lang="ts">
const { t } = useI18n()

useSeoMeta({
  title: t('pages.careers.meta.title'),
  description: t('pages.index.meta.description'),
})

const { data: jobsData, status } = await useLazyAsyncData(() =>
  createJobsRepository().getAll({
    sort: APIFilters.makeSort({ weight: 'ASC' }),
  })
)

const jobs = computed(() => jobsData.value?.items ?? [])
</script>

<template>
  <main>
    <UiBanner :title="$t('pages.careers.label')" />
    <div v-if="status === 'pending'">
      <UiSkeletonContentBlock />
    </div>
    <div v-else>
      <section
        v-if="jobs.length > 0"
        class="container grid grid-cols-1 gap-8 py-16"
      >
        <CareersCard v-for="job in jobs" :key="job.nid" :job="job" />
      </section>
    </div>
    <CareersContact />
  </main>
</template>
